<template>
    <div class="jcy-sync">
        <main class="content">
            <el-card>
                <el-button type="primary" size="mini" :loading="brandLoading" @click="handleRefreshBrand">同步品牌</el-button>
                <el-button type="primary" size="mini" :loading="saleUnitLoading" @click="handleRefreshSaleUnit">同步单位</el-button>
            </el-card>
        </main>
    </div>
</template>

<script>
export default {
    data() {
        return {
            brandLoading: false,
            saleUnitLoading: false,
        };
    },
    methods: {
        handleRefreshBrand() {
            this.brandLoading = true;
            this.$axios
                .get('/admin/tool/jcy/refreshBrand')
                .then(() => {
                    this.$message.success('品牌同步成功');
                })
                .catch(() => {
                    this.$message.error('品牌同步失败');
                })
                .finally(() => {
                    this.brandLoading = false;
                });
        },
        handleRefreshSaleUnit() {
            this.saleUnitLoading = true;
            this.$axios
                .get('/admin/tool/jcy/refreshSaleUnit')
                .then(() => {
                    this.$message.success('单位同步成功');
                })
                .catch(() => {
                    this.$message.error('单位同步失败');
                })
                .finally(() => {
                    this.saleUnitLoading = false;
                });
        },
    },
};
</script>

<style>
</style>
